import { type NavigationGuard } from 'vue-router';
import { useHelpStore } from '@/stores/help';

export const handleHelpWidgetClosing: NavigationGuard = async (to, from, next) => {
  const helpStore = useHelpStore();

  helpStore.closeDrawer();

  return next();
};
